/**
* Featured Blog Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Blog Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'featured-blog-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let oldIndex = 0;

      const sliders = [];
      $( '.splide--featured-blog-slider' ).each( function( key, slider ) {
        sliders[key] = new Splide( slider, {
          type: 'loop',
          pagination: false,
          arrows: true,
          gap: '20px',
          perPage: 3,
          perMove: 1,
          speed: 1000,
          breakpoints: {
            1024: {
              perPage: 2,
            },
            768: {
              perPage: 1,
            },
          },
        } );

        sliders[key].mount();

        sliders[key].on( 'move', function( newIndex, prevIndex, destIndex ) {
          console.log( newIndex, prevIndex, destIndex );
          if ( destIndex > oldIndex && destIndex !== -1 ) {
            $( '.splide--drag-images .splide__slide' ).addClass( 'is-dragging-left' );
          } else {
            $( '.splide--drag-images .splide__slide' ).addClass( 'is-dragging-right' );
          }

          setTimeout( function() {
            $( '.splide--drag-images .splide__slide' ).removeClass( 'is-dragging-left is-dragging-right' );
          }, 1000 );

          if ( destIndex == -1 ) {
            oldIndex = splide.length - 1;
          } else {
            oldIndex = newIndex;
          }
        } );

        sliders[key].on( 'overflow', function( isOverflow ) {
          sliders[key].options = {
            arrows: isOverflow,
            drag: isOverflow,
          };
        } );
      } );

      $( '.featured-blog-slider__filter' ).on( 'change', function() {
        $( '.featured-blog-slider__tab[data-toggle-target="#' + this.value + '"]' ).trigger( 'click' );
      } );

      const loadedTabs = [0];

      $( '.featured-blog-slider__tab' ).on( 'toggleAfter', function() {
        const target = $( this ).attr( 'data-toggle-target' ).substr( 1 );
        const key = $( '#' + target ).index() - 1;
        $( this ).closest( 'section' ).find( '.featured-blog-slider__filter' ).val( target );

        if ( loadedTabs.indexOf( key ) === -1 ) {
          setTimeout( function() {
            sliders[key].refresh();
            loadedTabs.push( key );
          }, 250 );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-blog-slider', COMPONENT );
} )( app );
